import wat.ui.App

fun main() {
    App.init()
}
